import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { translate } from 'react-polyglot';

import Link from '../Link';
import SvgIcon from '../SvgIcon';

import './ModalControlButton.scss';

class ModalControlButton extends Component {
  static defaultProps = {
    size: 's-m'
  }

  render() {
    const baseClassName = 'pb-modal-control-button';

    const {
      href,
      disabled,
      icon,
      label,
      onClick,
      size,
      section,
      t,
      outsideWrapper,
      closeOutsideWrapper,
      parentClassName
    } = this.props;

    const classes = {
      [baseClassName]: true,
      [parentClassName]: true,
      [`${baseClassName}--${size}`]: size,
      [`${baseClassName}--outside-wrapper`]: outsideWrapper,
      [`${baseClassName}__close--outside-wrapper`]: closeOutsideWrapper,
      [`${baseClassName}__disabled`]: disabled
    };

    return (
      <Link
        parentClassName={classNames(classes)}
        title={label}
        onClick={onClick}
        href={href}
        disabled={disabled}
        >
        <SvgIcon parentClassName={`${baseClassName}__icon`} name={icon} title={section ? (section === "offline-translate" ? null : t(`SvgTitle.${section}-${icon}`)) : t(`SvgTitle.${icon}`)} size={size} />
      </Link>
    );
  }
}

ModalControlButton.propTypes = {
  icon: PropTypes.string.isRequired,
  label: PropTypes.string,
  size: SvgIcon.propTypes.size,
  onClick: PropTypes.func,
  href: PropTypes.string,
  section: PropTypes.string
};

export default translate()(ModalControlButton);



// WEBPACK FOOTER //
// ./src/components/ModalControlButton/ModalControlButton.jsx